import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { environment } from '@env/environment';
import { HypecastAuthenticationService } from '@app/shared/authentication/services/authentication.service';
import { TenantFeatureService } from '@app/shared/services/tenant-feature.service';

import { NavigationLinkComponent } from './link/navigation-link.component';

/**
 * Basic navigation visible on all authenticated pages.
 */
@Component({
  selector: 'hypecast-admin-navigation',
  templateUrl: './navigation.component.html',
  styleUrl: './navigation.component.scss',
  standalone: true,
  imports: [NavigationLinkComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavigationComponent {
  private readonly authenticationService = inject(HypecastAuthenticationService);
  private readonly tenantFeatureService = inject(TenantFeatureService);
  /** Loaded before the shell renders (tenantFeaturesResolver), so the entries do not pop in. */
  private readonly features = this.tenantFeatureService.features;

  readonly isCollapsed = input(false);

  showAdminManagementEntry(): boolean {
    if (!(this.features()['scopedAdministrator'] ?? false)) {
      return this.isAnyAdministrator();
    }
    return this.isCompanyAdministrator();
  }

  showMeetingEntry(): boolean {
    if (environment.production === false) {
      return true;
    }
    return this.features()['meetings'] ?? false;
  }

  showAudioAiEntry(): boolean {
    if (environment.production === false) {
      return true;
    }
    return this.features()['audioAi'] ?? false;
  }

  isCompanyAdministrator(): boolean {
    return this.authenticationService.isCompanyAdministrator();
  }

  isAnyAdministrator(): boolean {
    return this.authenticationService.isAdministrator();
  }
}
